import "./Login.scss";

import React, {useEffect, useState} from "react";
import {batch, shallowEqual, useDispatch, useSelector} from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {updateHeaders} from "../../lib/AxiosConfig";
import {setCookie} from "../../lib/cookieHelper";
import {COOKIE_AUTHTOKEN, LOCALSTORAGE} from "../../const/dataEnum";
import {setAuthToken, setAvailableMenu, setUserInfo} from "../../stores/actions/appStateAction";
import {setLocalStorage} from "../../lib/localStorageHelper";
import {GoogleLogin} from "@react-oauth/google";
import authActionApi from "../../api/rest/authActionApi";
import logo from "../../assets/logo.png";


export default function Login() {
  const swVersion = useSelector((s) => s.appState.swVersion, shallowEqual);
  const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);


  async function handleSubmit(event) {
    event.preventDefault();
    await loginProcess();
  }

  async function loginProcess() {
    let param = {
      username: username,
      password: password,
    };
    setLoading(true);
    const response = await authActionApi.login(param);
    if (response) {
      const resData = response[0];
      setCookie(COOKIE_AUTHTOKEN, resData.authModel.token, {
        expires: new Date(resData.authModel.expiredOn).toUTCString(),
      });
      setLocalStorage(LOCALSTORAGE.COOKIE_EXPIRES, new Date(resData.authModel.expiredOn).toUTCString());
      batch(() => {
        dispatch(setAuthToken(resData.authModel.token));
        dispatch(updateHeaders());
        dispatch(setUserInfo(resData.employee));
        dispatch(setAvailableMenu(resData.authActions));
      });
    } else {
      setLoading(false);
    }
  }

  const handleOnSuccesGoogleLogin = async (response) => {
    setLoading(true);
    const res = await authActionApi.googleLogin(response.credential);
    if (res) {
      const resData = res[0];
      setCookie(COOKIE_AUTHTOKEN, resData.authModel.token, {
        expires: new Date(resData.authModel.expiredOn).toUTCString(),
      });
      setLocalStorage(LOCALSTORAGE.COOKIE_EXPIRES, new Date(resData.authModel.expiredOn).toUTCString());
      batch(() => {
        dispatch(setAuthToken(resData.authModel.token));
        dispatch(updateHeaders());
        dispatch(setUserInfo(resData.employee));
        dispatch(setAvailableMenu(resData.authActions));
      });
    }
    setLoading(false);
  };

  return (
    <div className="col-lg-6 col-md-8 col-sm-10 col-xs-12 loginPage">
      <div className="card background-dark">
        <div className="card-header text-white">
          <center>
            <img
              style={{width: "400px"}}
              src={logo}
              className="card-img-top mb-4"
              alt="Formulatrix Logo"
            />
          </center>
          <div className="signinwithgoogle-wrapper">
            <GoogleLogin onSuccess={handleOnSuccesGoogleLogin}/>
          </div>
          <h3 className="card-title">Employee Support System</h3>
        </div>
        <div className="card-body text-white">
          <Form onSubmit={handleSubmit}>
            <Form.Group size="lg" controlId="username" className="mb-2">
              <Form.Label className="form-label">Username</Form.Label>
              <Form.Control
                autoFocus
                placeholder="Enter Username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Group>
            <Form.Group size="lg" controlId="password" className="mb-2">
              <Form.Label className="form-label">Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <div className="user-auth-info">User authentication is provided by Tiga system. Password will not be saved in this system.</div>
            <Button
              size="md"
              type="submit"
              className="button-submit"
              disabled={username.length <= 0 || password.length <= 0 || loading}
            >
              {loading ? (
                <div>
                  <span
                    style={{marginLeft: "0px"}}
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
              ) : (
                "Login"
              )}
            </Button>
          </Form>
        </div>
        {swVersion ? (<div className="login--software-version">{`v${swVersion}`}</div>) : (<></>)}
      </div>
    </div>
  );
}